module.exports = __webpack_public_path__ + "static/media/Star-empty.98ee85c6.svg";